module.exports = __webpack_public_path__ + "img/uploadinggif.a8eab413.gif";